<template>
  <div>
    <div class="page-content">
      <div class="bg">
        <div class="footer">
          <a href="https://jirili-real.oss-cn-shanghai.aliyuncs.com/apk/noneed/ks_test.apk" class="download-btn">下载诸葛万年历</a>
          <p class="address">中国（上海）自有贸易试验区申江路5005弄3号2层01单元</p>
          <div class="content">
            <span>上海极客公社企业发展有限公司</span>
          </div>
          <p class="record"><a  class="record" href="http://www.beian.miit.gov.cn/">沪公网安备 31011502009399号 沪ICP备19011582号-2</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Floorpage',
};
</script>

<style scoped lang="scss">
  .bg{
    position: relative;
    background-image: url("~@/assets/image/home/newbg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    .footer{
      position: absolute;
      left: 0;
      bottom: 0;
      padding-top: 118px;
      width: 100%;
      height: 351px;
      background-image: url("~@/assets/image/home/bottom.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .download-btn{
        display: block;
        margin: 0 84px 38px 84px;
        border: none;
        height:78px;
        background:rgba(228,93,93,1);
        border-radius:39px;
        font-size:32px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:78px;
        text-align: center;
      }
      .address ,  .content , .record{
        text-align: center;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
      }
    }
  }
</style>
